var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPomMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "POMMobileIcon_svg__a",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "POMMobileIcon_svg__b",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 5.333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#2175D9",
    xlinkHref: "#POMMobileIcon_svg__a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "POMMobileIcon_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#POMMobileIcon_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#POMMobileIcon_svg__c)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.875 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.668 19.189a1.615 1.615 0 012.11-.87 1.602 1.602 0 01.873 2.1C3.31 21.24 0 25 0 25s.328-4.994.668-5.811z",
    fill: "#FFB511"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 4.92L5.459 2.038a11.985 11.985 0 00-4.193 5.225 11.96 11.96 0 00-.55 7.575c0 .005.005.013.005.018v.004l-.31.743a.801.801 0 00.436 1.048l2.236.921 2.236.922a.808.808 0 001.052-.435l.31-.743s.005 0 .005-.005c.004-.004.008-.004.013-.008a12.004 12.004 0 004.995-5.746 11.86 11.86 0 00.756-6.637z",
    fill: "#F7F5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 4.92A12.069 12.069 0 0010.402 0a12.188 12.188 0 00-4.943 2.038l6.99 2.882z",
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#0F1941",
    transform: "rotate(-67.5 7.307 7.438)",
    cx: 7.307,
    cy: 7.438,
    rx: 2.41,
    ry: 2.418
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E74536",
    transform: "rotate(-67.5 7.307 7.438)",
    cx: 7.307,
    cy: 7.438,
    rx: 1.609,
    ry: 1.615
  }))))));
}
export default "data:image/svg+xml;base64,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";
export { SvgPomMobileIcon as ReactComponent };